import React from "react";

const NotFound = () => <div>Página nao encontrada.</div>;

export default NotFound;
